import {
  InputLabel,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { get } from "lodash";
import React from "react";

import { INVOICE_STATUS_ITEMS_MAP } from "components/form/forms/voucher/InvoicesField";
import { formatDateForDisplay } from "components/form/standard/utils/formatting";
import { InvoiceActionsMenu } from "components/form_v2/detail/invoice/InvoiceActionsMenu";
import { DealBaseMetadata } from "constants/objectMetadata/dealMetadataV2";
import { useUsersDisplay } from "contexts/UserDisplayContext";
import { BROKER_ROLE_OPTIONS } from "pages/deal/constants/deal_enums";
import { formatCurrency, formatPercentage } from "pages/deal/utils/reporting";
import { CommissionSplitRead } from "types/api/deal/commissionSplit";
import { DealExtended } from "types/api/deal/dealExtended";
import { InvoiceRead } from "types/api/deal/invoice";

const CommissionShareDetail = ({ record }: { record: DealExtended }) => {
  const usersDisplay = useUsersDisplay();

  return (
    <Stack spacing={1}>
      <InputLabel> {DealBaseMetadata.commission_split.displayName}</InputLabel>
      <TableContainer>
        <Table sx={{ minWidth: 800 }}>
          <TableHead>
            <TableRow>
              <TableCell>Broker</TableCell>
              <TableCell>Commission&nbsp;%</TableCell>
              <TableCell>Commission (Gross)</TableCell>
              <TableCell>Broker Role</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {!!record.commission_split &&
              record.commission_split.map(
                (detail: CommissionSplitRead, index: number) => (
                  <TableRow key={index}>
                    <TableCell>{get(usersDisplay, detail.user_id)}</TableCell>
                    <TableCell>
                      {formatPercentage(detail.actual_percent)}
                    </TableCell>
                    <TableCell>
                      {formatCurrency(detail.actual_amount)}
                    </TableCell>
                    <TableCell>
                      {BROKER_ROLE_OPTIONS.find(
                        (o) => o.key === detail.broker_role
                      )?.label ?? "--"}
                    </TableCell>
                  </TableRow>
                )
              )}
          </TableBody>
        </Table>
      </TableContainer>
    </Stack>
  );
};

export default CommissionShareDetail;
